// frontend/src/components/modules/facilidades/FacilidadesModule.jsx
import React, { useState } from 'react';
import { useAuth } from '../../../context/AuthContext';
import AlmuerzosModule from '../almuerzos/AlmuerzosModule';
import CertificacionesModule from '../certificaciones/CertificacionesModule';
import { FaCalendarAlt } from "react-icons/fa";

// ── PALETA CORPORATIVA ────────────────────────────────────────
const C = {
  navy:      '#0a2540',
  navyMid:   '#0d3a5c',
  blue:      '#1e5cb3',
  blueMid:   '#2563eb',
  blueLight: '#eff6ff',
  border:    '#e2e8f0',
  bg:        '#f8fafc',
  bgCard:    '#ffffff',
  text:      '#0f172a',
  textMid:   '#334155',
  textSub:   '#64748b',
  textLight: '#94a3b8',
  green:     '#16a34a',
  greenBg:   '#f0fdf4',
};

// ── ICONOS SVG ────────────────────────────────────────────────

function AlmuerzoIcon({ size = 32, color = 'currentColor' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 11l19-9-9 19-2-8-8-2z" />
    </svg>
  );
}

function LearningIcon({ size = 32, color = 'currentColor' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
      <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" />
      <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" />
    </svg>
  );
}

function CertificacionIcon({ size = 32, color = 'currentColor' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14 2 14 8 20 8" />
      <line x1="16" y1="13" x2="8" y2="13" />
      <line x1="16" y1="17" x2="8" y2="17" />
      <polyline points="10 9 9 9 8 9" />
    </svg>
  );
}

// ── CATÁLOGO DE FACILIDADES ───────────────────────────────────
// Para agregar una nueva facilidad, solo agrega un objeto aquí
const FACILIDADES = [
  {
    id: 'almuerzos',
    nombre: 'Beneficio de Almuerzo',
    descripcion: 'Seleccione su opción de almuerzo para cada día de la semana. Beneficio institucional sin costo para el colaborador.',
    icono: AlmuerzoIcon,
    color: '#1e5cb3',
    colorBg: '#eff6ff',
    disponible: true,
  },
  {
    id: 'certificaciones',
    nombre: 'Certificaciones Laborales',
    descripcion: 'Solicite su certificación laboral para bancos, embajadas u otras entidades. Entrega los jueves, solicitudes hasta el martes al mediodía.',
    icono: CertificacionIcon,
    color: '#0a6640',
    colorBg: '#f0fdf4',
    disponible: true,
  },
  {
    id: 'learning-lab',
    nombre: 'ProDominicana Learning Lab',
    descripcion: 'Tu centro de desarrollo profesional. Accede a los programas de formación diseñados por la Dirección del Talento Humano para potenciar tus capacidades.',
    icono: LearningIcon,
    color: '#0a47ee',
    colorBg: '#f5f3ff',
    disponible: true,
    href: 'https://protalenthub.prodominicana.gob.do/learning/',
  },
  {
    id: 'monday',
    nombre: 'Acceso a Monday',
    descripcion: 'Plataforma oficial de gestión interna de ProDominicana. Organiza proyectos, iniciativas y procesos institucionales con tu equipo.',
    icono: FaCalendarAlt,
    color: '#0a47ee',
    colorBg: '#f5f3ff',
    disponible: true,
    href: 'https://prodominicana.monday.com/',
  },
  // ─── Próximas facilidades (descomentar cuando estén listas) ───
  // {
  //   id: 'transporte',
  //   nombre: 'Transporte Institucional',
  //   descripcion: 'Solicite su ruta de transporte para el traslado hacia y desde las instalaciones.',
  //   icono: TransporteIcon,
  //   color: '#16a34a',
  //   colorBg: '#f0fdf4',
  //   disponible: false,
  // },
];

// ── MAPA DE MÓDULOS INTERNOS ──────────────────────────────────
// Añade aquí los módulos que se renderizan dentro del portal (sin href)
const MODULOS_INTERNOS = {
  almuerzos:       { componente: AlmuerzosModule,       titulo: 'Beneficio de Almuerzo'     },
  certificaciones: { componente: CertificacionesModule, titulo: 'Certificaciones Laborales' },
};

// ── COMPONENTE PRINCIPAL ─────────────────────────────────────
export default function FacilidadesModule() {
  const { user } = useAuth();
  const [moduloActivo, setModuloActivo] = useState(null);

  // Renderizar módulo activo si existe en el mapa
  if (moduloActivo && MODULOS_INTERNOS[moduloActivo]) {
    const { componente: Componente, titulo } = MODULOS_INTERNOS[moduloActivo];
    return (
      <div style={{ minHeight: '100vh', background: C.bg, fontFamily: "'Segoe UI', system-ui, sans-serif" }}>
        {/* Breadcrumb / volver */}
        <div style={{
          background: C.navy,
          padding: '0.75rem 2rem',
          display: 'flex',
          alignItems: 'center',
          gap: '0.75rem',
        }}>
          <button
            onClick={() => setModuloActivo(null)}
            style={{
              background: 'rgba(255,255,255,0.1)',
              border: '1px solid rgba(255,255,255,0.2)',
              color: 'white',
              padding: '0.4rem 1rem',
              borderRadius: '0.375rem',
              fontSize: '0.78rem',
              fontWeight: '600',
              cursor: 'pointer',
              letterSpacing: '0.03em',
              display: 'flex',
              alignItems: 'center',
              gap: '0.4rem',
            }}
          >
            <span style={{ fontSize: '1rem', lineHeight: 1 }}>&#8592;</span>
            Facilidades
          </button>
          <span style={{ color: 'rgba(255,255,255,0.35)', fontSize: '0.8rem' }}>/</span>
          <span style={{ color: 'rgba(255,255,255,0.75)', fontSize: '0.8rem', fontWeight: '500' }}>
            {titulo}
          </span>
        </div>
        <Componente />
      </div>
    );
  }

  // ── PANTALLA HUB DE FACILIDADES ──────────────────────────────
  const nombreUsuario = user?.name?.split(' ')[0] || 'Colaborador';

  return (
    <div style={{ minHeight: '100vh', background: C.bg, fontFamily: "'Segoe UI', system-ui, sans-serif" }}>

      {/* ENCABEZADO */}
      <div style={{
        background: `linear-gradient(135deg, ${C.navy} 0%, ${C.navyMid} 55%, ${C.blue} 100%)`,
        padding: '2.5rem 2.5rem 2rem',
        borderBottom: '4px solid #1e5cb3',
      }}>
        <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
          <p style={{
            margin: '0 0 0.25rem',
            fontSize: '0.68rem',
            fontWeight: '700',
            color: 'rgba(255,255,255,0.45)',
            letterSpacing: '0.14em',
            textTransform: 'uppercase',
          }}>
            Portal del Colaborador — ProDominicana
          </p>
          <h1 style={{
            margin: '0 0 0.5rem',
            fontSize: '1.75rem',
            fontWeight: '700',
            color: 'white',
            letterSpacing: '-0.025em',
          }}>
            Facilidades Institucionales
          </h1>
          <p style={{
            margin: 0,
            fontSize: '0.925rem',
            color: 'rgba(255,255,255,0.65)',
            lineHeight: '1.5',
          }}>
            Bienvenido, <strong style={{ color: 'rgba(255,255,255,0.9)', fontWeight: '600' }}>{nombreUsuario}</strong>.
            Aquí puede gestionar los beneficios y facilidades disponibles para usted como colaborador de ProDominicana.
          </p>
        </div>
      </div>

      {/* CONTENIDO */}
      <div style={{ maxWidth: '1100px', margin: '0 auto', padding: '2.5rem 2rem 4rem' }}>

        {/* INFO INSTITUCIONAL */}
        <div style={{
          background: C.bgCard,
          border: `1px solid ${C.border}`,
          borderLeft: `4px solid ${C.blueMid}`,
          borderRadius: '0.75rem',
          padding: '1rem 1.5rem',
          marginBottom: '2.5rem',
          fontSize: '0.85rem',
          color: C.textSub,
          lineHeight: '1.6',
        }}>
          Los beneficios institucionales forman parte de la política de bienestar de ProDominicana para sus colaboradores.
          Si tiene alguna consulta, comuníquese con el Departamento de Recursos Humanos.
        </div>

        {/* TÍTULO DE SECCIÓN */}
        <div style={{ marginBottom: '1.5rem' }}>
          <h2 style={{
            margin: '0 0 0.25rem',
            fontSize: '1rem',
            fontWeight: '700',
            color: C.text,
            letterSpacing: '-0.01em',
          }}>
            Beneficios disponibles
          </h2>
          <p style={{ margin: 0, fontSize: '0.825rem', color: C.textSub }}>
            Seleccione el beneficio que desea gestionar.
          </p>
        </div>

        {/* GRID DE FACILIDADES */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
          gap: '1.25rem',
          marginBottom: '3rem',
        }}>
          {FACILIDADES.map((f, i) => (
            <TarjetaFacilidad
              key={`${f.id}-${i}`}
              facilidad={f}
              onAcceder={() => f.disponible && setModuloActivo(f.id)}
            />
          ))}
          <TarjetaProximamente />
        </div>

        {/* PIE DE PÁGINA INSTITUCIONAL */}
        <div style={{
          borderTop: `1px solid ${C.border}`,
          paddingTop: '1.5rem',
          textAlign: 'center',
        }}>
          <p style={{ margin: 0, fontSize: '0.78rem', color: C.textLight }}>
            Portal de Facilidades &mdash; ProDominicana &mdash; Departamento de Recursos Humanos
          </p>
        </div>
      </div>
    </div>
  );
}

// ── TARJETA DE FACILIDAD ─────────────────────────────────────
function TarjetaFacilidad({ facilidad, onAcceder }) {
  const [hover, setHover] = useState(false);
  const { nombre, descripcion, icono: Icono, color, colorBg, disponible, href } = facilidad;

  const handleAcceder = () => {
    if (!disponible) return;
    if (href) {
      window.open(href, '_blank', 'noopener,noreferrer');
    } else {
      onAcceder();
    }
  };

  return (
    <div
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        background: C.bgCard,
        border: `1.5px solid ${hover && disponible ? color : C.border}`,
        borderRadius: '1rem',
        padding: '1.75rem',
        boxShadow: hover && disponible ? '0 8px 24px rgba(0,0,0,0.1)' : '0 2px 6px rgba(0,0,0,0.05)',
        transition: 'all 0.2s ease',
        cursor: disponible ? 'pointer' : 'default',
        opacity: disponible ? 1 : 0.6,
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
        transform: hover && disponible ? 'translateY(-2px)' : 'none',
      }}
    >
      {/* Icono */}
      <div style={{
        width: '52px',
        height: '52px',
        background: colorBg,
        border: `1.5px solid ${color}30`,
        borderRadius: '0.875rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}>
        <Icono size={26} color={color} />
      </div>

      {/* Texto */}
      <div style={{ flex: 1 }}>
        <h3 style={{
          margin: '0 0 0.5rem',
          fontSize: '1rem',
          fontWeight: '700',
          color: C.text,
          letterSpacing: '-0.01em',
        }}>
          {nombre}
        </h3>
        <p style={{
          margin: 0,
          fontSize: '0.825rem',
          color: C.textSub,
          lineHeight: '1.55',
        }}>
          {descripcion}
        </p>
      </div>

      {/* Acción */}
      {disponible ? (
        <button
          onClick={handleAcceder}
          style={{
            padding: '0.6rem 0',
            background: hover ? color : 'transparent',
            border: `1.5px solid ${color}`,
            borderRadius: '0.5rem',
            color: hover ? 'white' : color,
            fontWeight: '700',
            fontSize: '0.8rem',
            cursor: 'pointer',
            letterSpacing: '0.04em',
            textTransform: 'uppercase',
            transition: 'all 0.15s ease',
            width: '100%',
          }}
        >
          Acceder
        </button>
      ) : (
        <div style={{
          padding: '0.6rem 0',
          background: '#f1f5f9',
          border: `1.5px solid ${C.border}`,
          borderRadius: '0.5rem',
          textAlign: 'center',
          fontSize: '0.75rem',
          fontWeight: '700',
          color: C.textLight,
          letterSpacing: '0.06em',
          textTransform: 'uppercase',
        }}>
          Próximamente
        </div>
      )}
    </div>
  );
}

// ── TARJETA PLACEHOLDER ──────────────────────────────────────
function TarjetaProximamente() {
  return (
    <div style={{
      background: 'repeating-linear-gradient(45deg, #f8fafc, #f8fafc 10px, #f1f5f9 10px, #f1f5f9 20px)',
      border: `1.5px dashed ${C.border}`,
      borderRadius: '1rem',
      padding: '1.75rem',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      gap: '0.75rem',
      minHeight: '200px',
      opacity: 0.65,
    }}>
      <div style={{
        width: '48px',
        height: '48px',
        background: C.border,
        borderRadius: '0.875rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '1.5rem',
        color: C.textLight,
      }}>
        +
      </div>
      <div>
        <p style={{ margin: '0 0 0.25rem', fontWeight: '700', fontSize: '0.875rem', color: C.textSub }}>
          Nuevas facilidades en desarrollo
        </p>
        <p style={{ margin: 0, fontSize: '0.78rem', color: C.textLight, lineHeight: '1.5' }}>
          El equipo de RRHH continúa incorporando beneficios adicionales para los colaboradores.
        </p>
      </div>
    </div>
  );
}